// AUTO-GENERATED by scripts/gen-networks.js — DO NOT EDIT.
// Environment : litvm
// Source      : settings/networks.litvm.json  (backend, single source of truth)
// Overlay     : src/config/environments/litvm.json  (presentation + routing)
// Regenerate  : REACT_APP_BRIDGE_ENV=litvm npm run gen:networks
import type { NetworkConfig } from '../types/bridge';

export type NetworkKey = 'litvm' | 'tbnb';

export const BRIDGE_ENV = 'litvm';

export const NETWORKS: Record<NetworkKey, NetworkConfig> = {
  "litvm": {
    "name": "LitVM Testnet",
    "evmNetworkSlug": "litvm",
    "chainId": 4441,
    "contractAddress": "0x87cDFbf2279EF93dE95152e6C02Ffe92805b2b20",
    "authorityNodes": [
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg1",
        "walletAddress": "0x2F487Eef3b29C16e02Ca987FA96e06E23c288b29",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg2",
        "walletAddress": "0xb599e6327743E22fBdC96e85BbD4Ae5A3f5dfecF",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg3",
        "walletAddress": "0x7212Fe4C7EAA236e0cA863C16f0C3dc1ec786753",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg4",
        "walletAddress": "0xFC09F2dB32531A24214F6Af23d659066CbDA4800",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg5",
        "walletAddress": "0xffc934205dAe0Ad09C2992D4aE084eFD2fb06eF5",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg6",
        "walletAddress": "0x68bA7745E77461664E9ad6B775C975350D387DcE",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg7",
        "walletAddress": "0x43ff8E3941c98aAD7682E4825cf5b9fc33951Cf2",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg8",
        "walletAddress": "0x9fC0f9A1Bc72f13FC1534bC66eBd7441b42A6d48",
        "httpScheme": "https"
      }
    ],
    "authorityThreshold": 5,
    "authorityHttpScheme": "https",
    "isTestnet": true,
    "decimals": 8,
    "rpcUrl": "https://liteforge.rpc.caldera.xyz/infra-partner-http",
    "explorerUrl": "https://liteforge.explorer.caldera.xyz",
    "nativeCurrency": {
      "name": "zkLTC",
      "symbol": "zkLTC",
      "decimals": 18
    },
    "dingoDepositConfirmations": 3,
    "dingoChangeConfirmations": 3
  },
  "tbnb": {
    "name": "BNB Testnet",
    "evmNetworkSlug": "tbnb",
    "chainId": 97,
    "contractAddress": "0x87cDFbf2279EF93dE95152e6C02Ffe92805b2b20",
    "authorityNodes": [
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg1",
        "walletAddress": "0x2F487Eef3b29C16e02Ca987FA96e06E23c288b29",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg2",
        "walletAddress": "0xb599e6327743E22fBdC96e85BbD4Ae5A3f5dfecF",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg3",
        "walletAddress": "0x7212Fe4C7EAA236e0cA863C16f0C3dc1ec786753",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg4",
        "walletAddress": "0xFC09F2dB32531A24214F6Af23d659066CbDA4800",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg5",
        "walletAddress": "0xffc934205dAe0Ad09C2992D4aE084eFD2fb06eF5",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg6",
        "walletAddress": "0x68bA7745E77461664E9ad6B775C975350D387DcE",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg7",
        "walletAddress": "0x43ff8E3941c98aAD7682E4825cf5b9fc33951Cf2",
        "httpScheme": "https"
      },
      {
        "location": "testnet.dingocoin.com",
        "port": 443,
        "path": "/wg8",
        "walletAddress": "0x9fC0f9A1Bc72f13FC1534bC66eBd7441b42A6d48",
        "httpScheme": "https"
      }
    ],
    "authorityThreshold": 5,
    "authorityHttpScheme": "https",
    "isTestnet": true,
    "decimals": 8,
    "rpcUrl": "https://bsc-testnet-rpc.publicnode.com",
    "explorerUrl": "https://testnet.bscscan.com",
    "nativeCurrency": {
      "name": "tBNB",
      "symbol": "tBNB",
      "decimals": 18
    },
    "dingoDepositConfirmations": 3,
    "dingoChangeConfirmations": 3
  }
};

export const DEFAULT_KEY: NetworkKey = 'litvm';

export const CHAIN_TO_KEY: Record<number, NetworkKey> = {
  "97": "tbnb",
  "4441": "litvm"
};

export interface WagmiChainSpec {
  id: number;
  name: string;
  nativeCurrency: { name: string; symbol: string; decimals: number };
  rpcUrl: string;
  explorerName: string;
  explorerUrl: string;
  testnet: boolean;
  /** Optional viem/chains built-in name (see wagmi.ts preset allowlist). */
  viemChain?: string;
}

export const WAGMI_CHAINS: WagmiChainSpec[] = [
  {
    "id": 4441,
    "name": "LitVM Testnet",
    "nativeCurrency": {
      "name": "zkLTC",
      "symbol": "zkLTC",
      "decimals": 18
    },
    "rpcUrl": "https://liteforge.rpc.caldera.xyz/infra-partner-http",
    "explorerName": "LitVM Explorer",
    "explorerUrl": "https://liteforge.explorer.caldera.xyz",
    "testnet": true
  },
  {
    "id": 97,
    "name": "BNB Testnet",
    "nativeCurrency": {
      "name": "tBNB",
      "symbol": "tBNB",
      "decimals": 18
    },
    "rpcUrl": "https://bsc-testnet-rpc.publicnode.com",
    "explorerName": "BscScan Testnet",
    "explorerUrl": "https://testnet.bscscan.com",
    "testnet": true,
    "viemChain": "bscTestnet"
  }
];

export const APP_META = {
  "appName": "wDingocoin Bridge",
  "walletConnectProjectId": "08e2c4cd7b75a298196dd225a454e11c"
} as const;
